export const body = document.getElementsByTagName('body')[0];

export const element = {
	parent: document.getElementById('search'),
	options: document.querySelectorAll('.search__options__item'),
	input: document.querySelector('.search__input'),
	submit: document.querySelector('.search__submit'),
	links: document.querySelectorAll('.search__options__link'),
	categories: document.querySelectorAll('.search__button'),
	close: document.querySelector('.search__options__close'),
	listSelector: '.search__options__list',
	linkSelector: '.search__options__link'
}
